/* eslint-disable arrow-body-style */
/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { Body, Container, Html, Section, Text } from "@react-email/components";
import PropTypes from "prop-types";

import HeadSection from "../HeadSection";
import FooterSection from "../FooterSection";
import { formatDeliveryDetails } from "../../../components/helper";
import HotelLogo from "../LogoSection/HotelLogo";

const GroceryEmailBeforeConfirmation = ({ data = {} }) => {
  const {
    food = "groceries",
    address = "Dubai 2/12 UAE",
    unitNumber = "101",
    paymentMethod = "stripe",
    cardNumber = "1234",
    type = "room",
    items = [{ ref: { title: "Item 1" }, totalPax: 1 }],
    beverages = [{ name: "Beverage Name", quantity: 1 }],
    locationName = "Holiday Inn",
    currency = "AED",
    scheduleDate = "2025‑04‑23 15:30:00",
    requestTime = "asap",
    locationLogo = "https://email-assets.lokalee.app/email/emailImages/logo.png",
  } = data;

  const isBreakfast = food === "breakfast";
  const orderTypeName = isBreakfast ? "breakfast" : "groceries";

  return (
    <Html>
      <HeadSection />
      <Body
        style={{
          lineHeight: "1.625",
          backgroundColor: "#f7fafc",
          fontFamily: "Arial, sans-serif",
        }}
      >
        <Container
          style={{
            padding: "0",
            maxWidth: "600px",
            marginLeft: "auto",
            marginRight: "auto",
            backgroundColor: "#ffffff",
            border: "1px solid #eaeaea",
          }}
        >
          {/* <LogoSection /> */}
          <HotelLogo image={locationLogo} />
          <Section
            style={{
              textAlign: "left",
              padding: "1.5rem 2rem 1rem 2rem",
            }}
          >
            <Text
              style={{
                margin: "0px",
                fontSize: "25px",
                color: "#222D29",
                fontWeight: "bold",
                marginBottom: "20px",
              }}
            >
              Thank you.
            </Text>
            <Text style={{ fontSize: "24px", color: "#222D29", marginBottom: "0rem" }}>
              We've received your {orderTypeName} order and are reviewing the details. You'll
              receive confirmation once the request has been processed. Here are the details of your
              request
            </Text>
          </Section>

          <Section
            style={{
              maxWidth: "536px",
              padding: "16px 24px",
              borderRadius: "11.54px",
              backgroundColor: "#F2F2F2",
              margin: "0 auto 24px auto",
            }}
          >
            <Text
              style={{
                margin: "0px",
                fontSize: "18px",
                color: "#222D29",
                fontWeight: "bold",
                marginBottom: "20px",
              }}
            >
              Order Summary
            </Text>
            <Text
              style={{
                margin: "0px",
                fontSize: "18px",
                color: "#222D29",
                marginTop: isBreakfast ? "0px" : "0px",
                marginBottom: "20px",
              }}
            >
              {type === "unit" ? "Unit Number:" : "Room Number:"} <strong>{unitNumber}</strong>
            </Text>
            <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "8px" }}>
              <thead>
                <tr style={{ borderBottom: "1px solid #ddd" }}>
                  <th
                    colSpan="2"
                    style={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: "#222D29",
                      textAlign: "left",
                    }}
                  >
                    ORDER DETAILS
                  </th>

                  <th
                    style={{
                      width: "100px",
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: "#222D29",
                      textAlign: "center",
                      padding: "6px",
                    }}
                  >
                    QUANTITY
                  </th>
                  <th
                    style={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      color: "#222D29",
                      textAlign: "right",
                      padding: "6px",
                    }}
                  >
                    PRICE
                  </th>
                </tr>
              </thead>

              <tbody>
                {items.map((item) => {
                  const { ref } = item;
                  const itemQuantity = item.totalPax;
                  const itemPrice = item.itemTotalPrice?.price?.recommendedRetailPrice;

                  let displayPrice;
                  if (itemPrice) {
                    displayPrice = `${item.currency || currency} ${itemPrice}`;
                  } else if (isBreakfast) {
                    displayPrice = `${currency}`;
                  } else {
                    displayPrice = "-";
                  }

                  return (
                    <tr key={ref?.title || item.title} style={{ borderBottom: "1px solid #ddd" }}>
                      <td
                        colSpan="2"
                        style={{
                          fontSize: "14px",
                          color: "#222D29",
                          padding: "",
                          textAlign: "left",
                        }}
                      >
                        {ref?.title || item.title}
                      </td>
                      <td
                        style={{
                          width: "100px",
                          fontSize: "14px",
                          color: "#222D29",
                          textAlign: "right",
                          padding: "6px",
                        }}
                      >
                        {itemQuantity}
                      </td>
                      <td
                        style={{
                          width: "100px",
                          fontSize: "14px",
                          color: "#222D29",
                          textAlign: "right",
                          padding: "6px",
                        }}
                      >
                        {displayPrice}
                      </td>
                    </tr>
                  );
                })}
              </tbody>

              {/* Conditionally render the beverages tbody */}
              {isBreakfast && (
                <tbody>
                  {beverages.map((bev) => {
                    const bevName = bev.name;
                    const bevQuantity = bev.quantity || 1;
                    const displayPrice = "-";

                    return (
                      <tr key={bevName} style={{ borderBottom: "1px solid #ddd" }}>
                        <td
                          colSpan="2"
                          style={{
                            fontSize: "14px",
                            color: "#222D29",
                            padding: "6px 0",
                            textAlign: "left",
                          }}
                        >
                          {bevName}
                        </td>
                        <td
                          style={{
                            width: "100px",
                            fontSize: "14px",
                            color: "#222D29",
                            textAlign: "right",
                            padding: "6px",
                          }}
                        >
                          {bevQuantity}
                        </td>
                        <td
                          style={{
                            width: "100px",
                            fontSize: "14px",
                            color: "#222D29",
                            textAlign: "right",
                            padding: "6px",
                          }}
                        >
                          {displayPrice}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              )}
            </table>
            {isBreakfast && (
              <div style={{ marginTop: "20px" }}>
                <Text
                  style={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: "#222D29",
                    margin: "0px",
                    paddingBottom: "4px",
                    borderBottom: "1px solid #ddd",
                    marginBottom: "4px",
                  }}
                >
                  DELIVERY DETAILS
                </Text>
                <Text
                  style={{
                    fontSize: "14px",
                    marginTop: "0",
                    color: "#222D29",
                    margin: "0px",
                  }}
                >
                  {formatDeliveryDetails(requestTime, scheduleDate)}
                </Text>
              </div>
            )}
            {paymentMethod === "No Payment Method" ? null : (
              <>
                <Text
                  style={{
                    fontSize: "14px",
                    color: "#222D29",
                    marginTop: "30px",
                    marginBottom: "4px",
                    paddingBottom: "4px",
                    fontWeight: "700",
                    lineHeight: "25.75px",
                    borderBottom: "1px solid #ddd",
                  }}
                >
                  PAYMENT METHOD
                </Text>
                <Text
                  style={{
                    fontSize: "14px",
                    marginTop: "0",
                    color: "#222D29",
                  }}
                >
                  {paymentMethod === "stripe" ? `VISA ****${cardNumber}` : paymentMethod}
                </Text>
              </>
            )}
            <Text
              style={{
                fontSize: "14px",
                color: "#222D29",
                marginTop: "30px",
                marginBottom: "4px",
                paddingBottom: "4px",
                fontWeight: "700",
                lineHeight: "25.75px",
                borderBottom: "1px solid #ddd",
              }}
            >
              DELIVERY ADDRESS
            </Text>
            <Text
              style={{
                fontSize: "14px",
                marginTop: "0",
                color: "#222D29",
              }}
            >
              {isBreakfast ? `${locationName}, ${unitNumber}, ${address}` : address}
            </Text>
          </Section>

          <Section
            style={{
              textAlign: "left",
              padding: "24px",
              marginLeft: "5px",
            }}
          >
            <Text
              style={{
                margin: "0px",
                fontSize: "16px",
                color: "#222D29",
              }}
            >
              For any inquiries, we would be happy to assist.
            </Text>{" "}
            <Text
              style={{
                margin: "0px",
                fontSize: "16px",
                color: "#222D29",
                marginBottom: "20px",
              }}
            >
              Please feel free to contact our{" "}
              <a
                href="mailto:cs@lokalee.app"
                style={{
                  fontSize: "16px",
                  color: "#222D29",
                  fontWeight: "bold",
                  textDecoration: "none",
                }}
              >
                <u>Help Center</u>
              </a>
            </Text>
            <Text
              style={{
                margin: "0px",
                fontSize: "20px",
                fontWeight: "700",
                color: "#222D29",
                marginBottom: "10px",
              }}
            >
              Thank you,
            </Text>
            <Text style={{ fontSize: "20px", color: "#222D29", fontWeight: "400", margin: "0px" }}>
              Lokalee Operations Team
            </Text>
          </Section>
          <FooterSection hasSocialLinks={false} />
        </Container>
      </Body>
    </Html>
  );
};

export default GroceryEmailBeforeConfirmation;

GroceryEmailBeforeConfirmation.propTypes = {
  data: PropTypes.shape({
    food: PropTypes.oneOf(["breakfast", "groceries"]),
    address: PropTypes.string,
    unitNumber: PropTypes.string,
    paymentMethod: PropTypes.string,
    cardNumber: PropTypes.string,
    type: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        ref: PropTypes.shape({
          title: PropTypes.string,
        }),
        totalPax: PropTypes.number,
        itemTotalPrice: PropTypes.instanceOf(Object),
        currency: PropTypes.string,
      })
    ),
    beverages: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        quantity: PropTypes.number,
      })
    ),
    locationName: PropTypes.string,
    currency: PropTypes.string,
    scheduleDate: PropTypes.string,
    requestTime: PropTypes.string,
    locationLogo: PropTypes.string,
  }),
};
